exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".handle[data-v-aabd5cd0] {\n  cursor: move;\n}\n.question-group-container span[data-v-aabd5cd0]:empty:before {\n  content: \"The question group is empty. Drop a question here...\";\n  margin-left: auto;\n  margin-right: auto;\n  display: block;\n  text-align: center;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n", ""]);

// exports
